module.exports = __webpack_public_path__ + "static/img/phone.71b8509.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone.png
// module id = UqHI
// module chunks = 9